exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart-wrapper[data-v-465d0ee6]{position:relative;height:400px}.motivation-declarations-chart[data-v-465d0ee6]{width:100%}", ""]);

// exports
